
// Non-hook version for use in render functions
const getUserPermissions = (user = {}, orgUserList, item, isOrg = false) => {

    console.log("user", user, "item", item, "isOrg", isOrg)

    if (!isOrg) {
        return {
            isView: true,
            isEdit: true
        }
    }

    const userId = user && user.info && user.info.id
    const isSuperAdmin = user && user.info && user.info.is_super_admin
    const isAdmin =
        user && user.info && user.info.role && user.info.role.name === 'Admin'


    //const { privacy = [], creator_id = null } = item

    const privacy = item?.privacy || []

    const creator_id = item?.creator_id || null

    const hasDefaultAccess = userId === creator_id

    if (hasDefaultAccess) {
        return {
            isView: true,
            isEdit: true
        }
    }
    const userOrg = orgUserList.find(el => userId === el.user_id)
    let groupIdList = userOrg && userOrg.user && userOrg.user.groups && userOrg.user.groups.map(item => item.id)


    const userPrivacy = privacy.find(p => p.user_id === userId)
    const groupPrivacy = privacy.find(p => p.user_id === userId && groupIdList.includes(p.group_id))

    let isView = false
    let isEdit = false
    if (userPrivacy || groupPrivacy) {
        isEdit = groupPrivacy && groupPrivacy.access_type === 'edit' || userPrivacy && userPrivacy.access_type === 'edit'
        isView = groupPrivacy && groupPrivacy.access_type === 'view' || userPrivacy && userPrivacy.access_type === 'view' || isEdit // view is a subset of edit
    } else {
        isView = true
        isEdit = true
    }

    return {
        isView,
        isEdit
    }
}

export { getUserPermissions }
